var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import clientUrlConfig from "@adapters/infrastructures/urlConfig/SalesJourney/Clients/ClientsURL";
import { cilentHeaderAccCodeMapper } from "@domains/salesFeatures/Clients/mappers/clientHeaderAccCodeMapper";
import { clientOverviewMapper } from "@domains/salesFeatures/Clients/mappers/clientOverview";
import { clientHeaderAUMMapper } from "@domains/salesFeatures/Clients/mappers/ClientHeaderAUMDetailsMapper";
import { clientSearchMapper } from "@domains/salesFeatures/Clients/mappers/clientSearchMapper";
import { clientMultipleContactsMapper } from "@domains/salesFeatures/Clients/mappers/clientMultipleContactsMapper";
import { clientMCAccessMapper } from "@domains/salesFeatures/Clients/mappers/clientMCAccessMapper";
import { passwordResentHistoryMapper } from "@domains/salesFeatures/Clients/mappers/passwordResentHistory";
import { ownerHistoryMapper } from "@domains/salesFeatures/Clients/mappers/ownerHistoryMapper";
import { dpDetailsMapper } from "@domains/salesFeatures/Clients/mappers/dpDetailsMapper";
import { familyMemDetailsMapper, familyTaggingSearchMapper, } from "@domains/salesFeatures/Clients/mappers/familyMenDetailsMapper";
import { bankDetailsMapper } from "@domains/salesFeatures/Clients/mappers/clientBankDetailsmapper";
import { clientPassthroughMapper } from "@domains/salesFeatures/Clients/mappers/clientPassthroughMapper";
import { commonFamilyMemDetailsMapper, deleteFamilyMapper, deleteFamilyMember, } from "@domains/salesFeatures/Clients/mappers/commonFamilyMemDetails";
import { historicalViewMapper } from "@domains/salesFeatures/Clients/mappers/historicalViewMapper";
import { revenueAUMDataMapper } from "@domains/salesFeatures/Clients/mappers/revenueAUMDataMapper";
import { revenueActiveLoansMapper } from "@domains/salesFeatures/Clients/mappers/revenueActiveLoansMapper";
import { revenueActiveLoansDetailsMapper } from "@domains/salesFeatures/Clients/mappers/revenueActiveLoansDetailsMapper";
import { clientOwnersMapper } from "@domains/salesFeatures/Clients/mappers/clientOwnersMapper";
import { upiDetailsMapper } from "@domains/salesFeatures/Clients/mappers/upiDetailsMapper";
import { eligibilityDetailsMapper } from "@domains/salesFeatures/Clients/mappers/eligibilityDetailsMapper";
import { pastIntractionDetailsMapper } from "@domains/salesFeatures/Clients/mappers/pastIntractionDetailsMapper";
import { loaDetailsMapper } from "@domains/salesFeatures/Clients/mappers/loaDetailsMapper";
import { npsDetailsMapper } from "@domains/salesFeatures/Clients/mappers/npsDetailsMapper";
import { dpcDetailsMapper } from "@domains/salesFeatures/Clients/mappers/dpcDetailsMapper";
import { brokingVolumeDetailsMapper } from "@domains/salesFeatures/Clients/mappers/brokingVolumeDetails";
import { brokingPlanMapper } from "@domains/salesFeatures/Clients/mappers/brokingPlanMapper";
import { thirdPartyPOADetailsMapper } from "@domains/salesFeatures/Clients/mappers/thirdPartyPOADetailsMaapper";
import { clientLifeCycleDetailsMapper } from "@domains/salesFeatures/Clients/mappers/clientLifeCycleDetails";
import { clientDpLedgerGetCatogeryDetailsMapper } from "@domains/salesFeatures/Clients/mappers/clientDpIdMapper";
import { clientDpLedgerDetailsMapper } from "@domains/salesFeatures/Clients/mappers/clientDpLedgerDetailsMapper";
import { adbSchemeWiseDetailsMapper } from "@domains/salesFeatures/Clients/mappers/adbSchemeWiseDetailsMapper";
import { clientBackOfficeUrlMapper } from "@domains/salesFeatures/Clients/mappers/clientBackOfficeUrlMapper";
import { mfOrderBookMapper } from "@domains/salesFeatures/Clients/mappers/mfOrderBookMapper";
import { mfRegistrationBookMapper } from "@domains/salesFeatures/Clients/mappers/mfRegistrationBookMapper";
import { payingDetailsMapper } from "@domains/salesFeatures/Clients/mappers/iPayingDetails";
import { adbRenewalMapper } from "@domains/salesFeatures/Clients/mappers/adbRenewalMapper";
import { aumSummaryDetailsMapper } from "@domains/salesFeatures/Clients/mappers/aumSummaryDetails";
import { fnoMarginDetailsMapper } from "@domains/salesFeatures/Clients/mappers/fnoMarginMapper";
import { InsuranceDataMapper } from "@domains/salesFeatures/Clients/mappers/InsuranceDataMapper";
import { paylinkReportsDetailsMapper } from "@domains/salesFeatures/Clients/mappers/paylinkReportsDetails";
import { getCountryCodeMasterDataMapper } from "@domains/salesFeatures/Clients/mappers/getCountryCodeMapper";
import { getMortageDetailsMapper } from "@domains/salesFeatures/Clients/mappers/getMortageDetailsMapper";
import { editUPIMapper } from "@domains/salesFeatures/Clients/mappers/editUPIMapper";
import { getPaylinkScenarioMapper } from "@domains/salesFeatures/Clients/mappers/paylinkScenarioMapper";
import { addUPIDetailsMapper } from "@domains/salesFeatures/Clients/mappers/addUPIDetailsMapper";
import { getDataFromQRCMapper } from "@domains/salesFeatures/Clients/mappers/GetDataFromQRCMapper";
import { getIncomeDeclarationGetClientTypeMapper } from "@domains/salesFeatures/Clients/mappers/IncomeDeclarationGetClientTypeMapper";
import { getIncomeDeclarationGetNonClientTypeMapper } from "@domains/salesFeatures/Clients/mappers/IncomeDeclarationGetNonClientTypeMapper";
import { getBankDetailsMandateFormsMapper } from "@domains/salesFeatures/Clients/mappers/getBankDetailsMandateForms";
import { getRazorPayAccountDetailsMapper } from "@domains/salesFeatures/Clients/mappers/getRazorPayAccountDetailsMapper";
import { ViewIncomeDeclarationMapper } from "@domains/salesFeatures/Clients/mappers/ViewIncomeDeclarationMapper";
import { ViewIncomeDeclarationSRMapper } from "@domains/salesFeatures/Clients/mappers/ViewIncomeDeclarationSRMapper";
import { IncomeRangeMapper } from "@domains/salesFeatures/Clients/mappers/IncomeRangeMapper";
import { brokingAccountMapper } from "../../../../domains/salesFeatures/Clients/mappers/brokingAccountMapper";
import { GetDPDetailsByDPIdMapper } from "@domains/salesFeatures/Clients/mappers/getDPDetailsByDPIdMapper";
import { GetExceptionlsinMapper } from "@domains/salesFeatures/Clients/mappers/getExceptionlsinMapper";
import { GetExceptionDataMapper } from "@domains/salesFeatures/Clients/mappers/getExceptionDataMapper";
import { GetExceptionSegmentMapper } from "@domains/salesFeatures/Clients/mappers/GetExceptionSegment";
import { adbCommonOfferMapper } from "@domains/salesFeatures/Clients/mappers/adbCommonOfferMapper";
import { mfRegistrationBookAccodeMapper } from "@domains/salesFeatures/Clients/mappers/mfRegistrationBookAccodeMapper";
import { revenueFnoMarginMapper } from "@domains/salesFeatures/Clients/mappers/revenueFnoMarginMapper";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import deletePoaMapper from "../../../../domains/salesFeatures/Clients/mappers/deletePoaMapper";
import { dncStdMapper } from "@domains/salesFeatures/Clients/mappers/dncStdMapper";
import { DNCPendingStsMapper } from "@domains/salesFeatures/Clients/mappers/DNCPendingStsMapper";
import { DNCDataMapper } from "@domains/salesFeatures/Clients/mappers/DNCDataMapper";
import { POAEdisMapper } from "@domains/salesFeatures/Clients/mappers/POAEdisMapper";
import { FNOAvailableCashDataMapper } from "@domains/salesFeatures/Clients/mappers/fnoAvailableCashMapper";
import CKYCDetailsMapper from "@domains/salesFeatures/Clients/mappers/CKYCDetailsMapper";
import SaveCkycDetailsMapper from "@domains/salesFeatures/Clients/mappers/SaveCKYCDetails";
import { GetThirdPartyPOADetailsMapper } from "@domains/salesFeatures/Clients/mappers/GetThirdPartyPOADetailsMapper";
import { AumInsuranceMapper } from "@domains/salesFeatures/Clients/mappers/AumInsuranceMapper";
import { ValidateParamsMapper } from "@domains/salesFeatures/Clients/mappers/ValidateParamsMapper";
import { ValidateParamsExchangeMapper } from "@domains/salesFeatures/Clients/mappers/ValidateParamsExchangeMapper";
import { HomogenousGetTierCurrentStatusMapper } from "@domains/salesFeatures/Clients/mappers/HomogenousGetTierCurrentStatusMapper";
import { getRazorPayTransactionDetailsMapper } from "@domains/salesFeatures/Clients/mappers/iGetRazorPayTransactionDetails";
import { PlatformFnoDetailsMapper } from "@domains/salesFeatures/Clients/mappers/PlatformFnoDetailsMapper";
import searchClientsByRmWithOwnClientMapper from "@domains/salesFeatures/Clients/mappers/searchClientsByRmWithOwnClientMapper";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
var ClientRepository = /** @class */ (function () {
    function ClientRepository(http) {
        this.http = http;
    }
    ClientRepository.prototype.getfamilyDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, familyDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getfamilyDetails);
                        url.searchParams.append("AccCode", req.AccCode);
                        url.searchParams.append("forMobile", req.forMobile.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        familyDetails = _a.sent();
                        return [2 /*return*/, familyDetails];
                }
            });
        });
    };
    ClientRepository.prototype.getDpNomineeDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, dpNomineeDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getDpNomineeDetails);
                        url.searchParams.append("Accode", req.Accode);
                        url.searchParams.append("BOID", req.BOID);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        dpNomineeDetails = _a.sent();
                        return [2 /*return*/, dpNomineeDetails];
                }
            });
        });
    };
    ClientRepository.prototype.getFnoConsentDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, fnoDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getFnoConsentDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        fnoDetails = _a.sent();
                        // const getPaylinkResp = getPaylinkReport;
                        return [2 /*return*/, PlatformFnoDetailsMapper(fnoDetails)];
                }
            });
        });
    };
    ClientRepository.prototype.getQRCDocDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, getPaylinkResp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.QRCDocDetails);
                        url.searchParams.append("flag", req.flag);
                        url.searchParams.append("acCode", req.acCode);
                        url.searchParams.append("IsDematBank", req.IsDematBank);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        getPaylinkResp = _a.sent();
                        // const getPaylinkResp = getPaylinkReport;
                        return [2 /*return*/, getPaylinkResp.data];
                }
            });
        });
    };
    ClientRepository.prototype.getPaylinkReport = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, getPaylinkResp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getPaylinkReport);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        getPaylinkResp = _a.sent();
                        //const getPaylinkResp = getPaylinkReport;
                        return [2 /*return*/, getPaylinkResp.data];
                }
            });
        });
    };
    ClientRepository.prototype.getHomogenousTierCurrentStatusData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, homogenousResp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.HomogenousGetTierCurrentStatus);
                        url.searchParams.append("PAN", req.pan);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        homogenousResp = _a.sent();
                        return [2 /*return*/, HomogenousGetTierCurrentStatusMapper(homogenousResp.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getValidateParamsExchangeData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, validateParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.ValidateparamForExchange);
                        url.searchParams.append("acCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        validateParams = _a.sent();
                        return [2 /*return*/, ValidateParamsExchangeMapper(validateParams.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getValidateParams = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, validateParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.ValidateParam);
                        url.searchParams.append("acCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        validateParams = _a.sent();
                        return [2 /*return*/, ValidateParamsMapper(validateParams.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getAumInsuranceData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, aumInsuranceResp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getAumInsurance);
                        url.searchParams.append("accode", req.accode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        aumInsuranceResp = _a.sent();
                        return [2 /*return*/, AumInsuranceMapper(aumInsuranceResp.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getThirdPartyPOAData = function (accCode) {
        return __awaiter(this, void 0, void 0, function () {
            var url, getThirdPartyDetailsData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getThirdPartyPOADetails);
                        url.searchParams.append("accode", accCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        getThirdPartyDetailsData = _a.sent();
                        return [2 /*return*/, GetThirdPartyPOADetailsMapper(getThirdPartyDetailsData.data)];
                }
            });
        });
    };
    ClientRepository.prototype.saveThirdPartyPOA = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, thirdPartyPOAResp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.saveThirdPartyPOADetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        thirdPartyPOAResp = _a.sent();
                        return [2 /*return*/, thirdPartyPOAResp];
                }
            });
        });
    };
    ClientRepository.prototype.getRevenueFnoMarginData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, revenueFnoMargin;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.revenueFnoMargin);
                        url.searchParams.append("acCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        revenueFnoMargin = _a.sent();
                        return [2 /*return*/, revenueFnoMarginMapper(revenueFnoMargin.data)];
                }
            });
        });
    };
    ClientRepository.prototype.sendMandateMail = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.mandateEmail);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ClientRepository.prototype.getMandateSampleFile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.mandateSampleFile);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ClientRepository.prototype.getMandateDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.MandateDetail);
                        url.searchParams.append("Accode", req.Accode);
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ClientRepository.prototype.getValidateBank = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.GetValidateBank);
                        url.searchParams.append("accode", req.accode);
                        url.searchParams.append("BankName", req.BankName);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ClientRepository.prototype.updatePlatformSMTFReq = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.updatePlatformSMTFReq);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ClientRepository.prototype.getIncomeRange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, viewIncomeDeclaration;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getIncomeRange);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "100");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        viewIncomeDeclaration = _a.sent();
                        return [2 /*return*/, IncomeRangeMapper(viewIncomeDeclaration.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getViewIncomeDeclarationSRDetails = function (accountCode) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, viewIncomeDeclaration;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(clientUrlConfig.viewIncomeDeclarationSR);
                        url.searchParams.append("Accode", accountCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        viewIncomeDeclaration = _b.sent();
                        return [2 /*return*/, ViewIncomeDeclarationSRMapper((_a = viewIncomeDeclaration.data) === null || _a === void 0 ? void 0 : _a.serviceData)];
                }
            });
        });
    };
    ClientRepository.prototype.getViewIncomeDeclarationDetails = function (accountCode) {
        return __awaiter(this, void 0, void 0, function () {
            var url, viewIncomeDeclaration;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.viewIncomeDeclaration);
                        url.searchParams.append("Accode", accountCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        viewIncomeDeclaration = _a.sent();
                        if (viewIncomeDeclaration.data && viewIncomeDeclaration.data.result)
                            return [2 /*return*/, ViewIncomeDeclarationMapper(viewIncomeDeclaration.data.result)];
                        return [2 /*return*/, {}];
                }
            });
        });
    };
    ClientRepository.prototype.getClientSearchData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.search);
                        url.searchParams.append("SearchText", req.searchText);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, clientSearchMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientHeaderAccCodeData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.headerAccCode);
                        url.searchParams.append("AcCode", req.accCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, cilentHeaderAccCodeMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientOverviewData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientOverview);
                        url.searchParams.append("AcCode", req.accCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, clientOverviewMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientHeaderAUMData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.headerAUM);
                        url.searchParams.append("AcCode", req.accCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, clientHeaderAUMMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientMultipleContactData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientMultipleContact);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, clientMultipleContactsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientMCAccessData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientMCAssess);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, clientMCAccessMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getPasswordResentHistoryData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.passwordResentHistory);
                        url.searchParams.append("Accode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, passwordResentHistoryMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getOwnerHistoryData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.ownerHistory);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, ownerHistoryMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getDpDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.dpDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, dpDetailsMapper(result.data, req.acCode)];
                }
            });
        });
    };
    ClientRepository.prototype.getFamilyMemDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.FamilyMemberDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, familyMemDetailsMapper(result === null || result === void 0 ? void 0 : result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientBankDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.bankDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, bankDetailsMapper(result.data, req.acCode)];
                }
            });
        });
    };
    ClientRepository.prototype.addfamilyMemDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.familyTagging);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, commonFamilyMemDetailsMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.deleteFamily = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.FamilyDetails);
                        url.searchParams.append("Accode", req.acCode);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, deleteFamilyMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.deleteFamilyMember = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.deleteFamileMember);
                        url.searchParams.append("acCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, deleteFamilyMember(result)];
                }
            });
        });
    };
    ClientRepository.prototype.historicalViewData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.historicalView);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, historicalViewMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientPlatformsDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.platformsDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    ClientRepository.prototype.getClientConsentDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result, resultEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.consentDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        resultEntity = {
                            data: "",
                        };
                        resultEntity.data = result.data;
                        return [2 /*return*/, resultEntity];
                }
            });
        });
    };
    ClientRepository.prototype.getOwnersInformation = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.owners);
                        url.searchParams.append("Accode", req.Accode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, clientOwnersMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getRevenueAUMData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.RevAUMData);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, revenueAUMDataMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.getRevenueActiveLoans = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.activeLoans);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, revenueActiveLoansMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.getRevenueActiveLoanDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.activeLoanDetails);
                        url.searchParams.append("Accode", req.Accode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, revenueActiveLoansDetailsMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientUPIDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.upiDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, upiDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientLOADetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.loaDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, loaDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getNPSDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.npsDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, npsDetailsMapper(result === null || result === void 0 ? void 0 : result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getDPCDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.dpcDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        url.searchParams.append("flg", (req === null || req === void 0 ? void 0 : req.flag) ? req.flag : "1");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, dpcDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getBrokVolumeDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.brokVolDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, brokingVolumeDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getBrokingPlanDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.brokingPlan);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, brokingPlanMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getEligibilityDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.eligibilityDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, eligibilityDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getPastIntractionDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.pastIntractionDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        if (!!req.fromDate && req.fromDate !== "")
                            url.searchParams.append("FromDate", req.fromDate);
                        if (!!req.toDate && req.toDate !== "")
                            url.searchParams.append("ToDate", req.toDate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, pastIntractionDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getThirdPartyPOADetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.thirdPartyPOADetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, thirdPartyPOADetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientLifeCycleDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientLifeCycleDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, clientLifeCycleDetailsMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientDpLedgerGetCatogeryDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientDpLedgerGetCatogeryDetails);
                        url.searchParams.append("DpId", req.DpId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, clientDpLedgerGetCatogeryDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientDpLedgerDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientDpLedgerDetails);
                        url.searchParams.append("DpId", req.DpId);
                        url.searchParams.append("CategoryID", req.CategoryID);
                        url.searchParams.append("ForDate", req.ForDate);
                        url.searchParams.append("downloadFlag", req.downloadFlag.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        // if (req.downloadFlag) result = JSON.parse(dummydownloadDpLedger);
                        return [2 /*return*/, clientDpLedgerDetailsMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.getADBSchemeWiseDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.adbSchemeWiseDetails);
                        url.searchParams.append("accode", req.acCode);
                        url.searchParams.append("schemeNo", req.schemeNo);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "100");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, adbSchemeWiseDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientPassthrouhData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientPassthrough);
                        url.searchParams.append("Accode", req.acCode);
                        url.searchParams.append("empcodeTxt", req.empcodeTxt);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, clientPassthroughMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getClientBackOfficeUrlData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.backOfficeUrl);
                        url.searchParams.append("AcCode", req.acCode);
                        url.searchParams.append("Year", req.year);
                        url.searchParams.append("empName", req.empName);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, clientBackOfficeUrlMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getMFOrderBookData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result, mfOrderBookEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.mfOrderBook);
                        url.searchParams.append("AcCode", req.acCode);
                        url.searchParams.append("Status", req.status);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "500");
                        if (req.downloadFlag) {
                            url.searchParams.append("downloadFlag", String(req.downloadFlag));
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        mfOrderBookEntity = {
                            mflistResponseEntity: [],
                            downloadMFResponseEntity: "",
                        };
                        if (result && (result === null || result === void 0 ? void 0 : result.data) && typeof (result === null || result === void 0 ? void 0 : result.data) === "string") {
                            mfOrderBookEntity.downloadMFResponseEntity = result.data;
                        }
                        else {
                            mfOrderBookEntity.mflistResponseEntity = mfOrderBookMapper(result.data);
                        }
                        return [2 /*return*/, mfOrderBookEntity];
                }
            });
        });
    };
    ClientRepository.prototype.getPayingDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.payingDetails);
                        url.searchParams.append("AcCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, payingDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getADBRenewalDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.adbRenewel);
                        url.searchParams.append("Accode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, adbRenewalMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.getADBCurrentPlansData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.adbCurrentPlans);
                        url.searchParams.append("acCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    ClientRepository.prototype.getCurrentPlanData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.newCurrentPlan);
                        url.searchParams.append("Accode", req.acCode);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "100");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    ClientRepository.prototype.getBrokingADBDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.adbDetails);
                        url.searchParams.append("Accode", req.acCode);
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    ClientRepository.prototype.getADBDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.newAdbDetails);
                        url.searchParams.append("accode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    ClientRepository.prototype.getADBSchemeWiseData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.adbSchemeWise);
                        url.searchParams.append("AcCode", req.acCode);
                        url.searchParams.append("schemeCode", req.schemeCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, adbSchemeWiseDetailsMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.getMFRegistrationBookData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.mfRagistrationBook);
                        url.searchParams.append("AcCode", req.acCode);
                        url.searchParams.append("Status", req.status);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "500");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, mfRegistrationBookMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getAUMSummaryDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.aumSummaryDetails);
                        url.searchParams.append("AcCode", req.AcCode);
                        url.searchParams.append("Flag", req.Flag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, aumSummaryDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getFNOMarginDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.fnoMarginDetails);
                        url.searchParams.append("AcCode", req.AcCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, fnoMarginDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getRevenueInsuranceData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.revenueInsuranceData);
                        url.searchParams.append("AcCode", req.AcCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, InsuranceDataMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getPaylinkReportsDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.paylinkReportsDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, paylinkReportsDetailsMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.generatePaymentLink = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result, resultEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.generatePaymentLink);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        resultEntity = {
                            data: result.data,
                        };
                        return [2 /*return*/, resultEntity];
                }
            });
        });
    };
    ClientRepository.prototype.getCountryCodeMasterData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getCountryCodeMasterDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, getCountryCodeMasterDataMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.killPaymentLink = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.killPaymentLink);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getMortageDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getMortageDetails);
                        url.searchParams.append("AcCode", req.AcCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, getMortageDetailsMapper(result === null || result === void 0 ? void 0 : result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.saveMortageDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getMortageDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getPaylinkScenarioData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getPaylinkScenarioDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, getPaylinkScenarioMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getRevenueADBActiveoffer = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.adbActiveOffer);
                        url.searchParams.append("AcCode", req.AcCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, adbCommonOfferMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getRevenueADBExpiredoffer = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.adbExpiredOffer);
                        url.searchParams.append("AcCode", req.AcCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, adbCommonOfferMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getRevenueADBFutureoffer = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.adbFutureOffer);
                        url.searchParams.append("AcCode", req.AcCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, adbCommonOfferMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.editUPIdetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.addeditUPIDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, editUPIMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.clientAddContact = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientMultipleContact);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getMasterRelation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.masterRelation);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    ClientRepository.prototype.addupiDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.addeditUPIDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, addUPIDetailsMapper(result)];
                }
            });
        });
    };
    ClientRepository.prototype.getEmandateData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.eMandateDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getRefIdDetials = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getRefIdDetails);
                        url.searchParams.append("Accode", req.Accode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, { result: result.data }];
                }
            });
        });
    };
    ClientRepository.prototype.requestMandate = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.requestMandate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: __assign({}, req),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.deleteLOA = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.deleteLOA);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: __assign({}, req),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getPastInteractionDownloadData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.pastInteractionDownload);
                        url.searchParams.append("FromDate", req.fromDate);
                        url.searchParams.append("ToDate", req.toDate);
                        url.searchParams.append("accode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getDataFromQRC = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getDataFromQRC);
                        url.searchParams.append("Pan", req.Pan);
                        url.searchParams.append("FromDate", req.FromDate);
                        url.searchParams.append("ToDate", req.ToDate);
                        url.searchParams.append("parent_id", leadStatusConfig.parentId.toString());
                        url.searchParams.append("viewType", leadStatusConfig.viewType);
                        //url.searchParams.append("isStatusCode", req.isStatusCode);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "500");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, getDataFromQRCMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.incomeDeclarationGetClientType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getIncomeDeclarationGetClientType);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, getIncomeDeclarationGetClientTypeMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.incomeDeclarationGetNonClientType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getIncomeDeclarationGetNonClientType);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, getIncomeDeclarationGetNonClientTypeMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getPlatformSMTFAcceptReject = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getPlatformSMTFAcceptReject);
                        url.searchParams.append("Accode", req.Accode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getPlatformBSERequest = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getPlatformBSERequest);
                        url.searchParams.append("Accode", req.Accode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.sendLoaDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.sendLoaDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getBankDetailsMandateForms = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getBankDetailsMandateForms);
                        url.searchParams.append("Accode", req.Accode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, getBankDetailsMandateFormsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getBankBranchDetailsMandateForms = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getBankBranchDetailsMandateForms);
                        url.searchParams.append("Accode", req.Accode);
                        url.searchParams.append("BankName", req.BankName);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    ClientRepository.prototype.postPlatformBSERequestAccept = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.postPlatformBSERequestAccept);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.saveLoaDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.saveLoaDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.postPlatformBSEUpload = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, reqObj, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("mfConsentFile", req.MfConsentFile);
                        url = new URL(clientUrlConfig.postPlatformBSEUpload);
                        reqObj = {
                            accode: req.Accode,
                            mfConsentFile: req.MfConsentFile,
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: reqObj,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.postPlatformReactivationLink = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.postPlatformReactivationLink);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getRazorPayAccountDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getRazorPayAccountDetails);
                        url.searchParams.append("Accode", req.Accode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, getRazorPayAccountDetailsMapper(result === null || result === void 0 ? void 0 : result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getRazorPayTransactionDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getRazorPayTransDetails);
                        url.searchParams.append("Accode", req.Accode);
                        url.searchParams.append("isCustomerCreated", req.isCustomerCreated);
                        url.searchParams.append("isVirtualAccountCreated", req.isVirtualAccountCreated);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, getRazorPayTransactionDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getSearchFamilyTagging = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.familySearch);
                        url.searchParams.append("searchValue", req.searchValue);
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, familyTaggingSearchMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.brokingAccountDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.brokingAccountDetails);
                        url.searchParams.append("Accode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, brokingAccountMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.downloadPrismReport = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.downloadPrismReports);
                        url.searchParams.append("Accode", req.Accode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getPartnerStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getPartnerStatus);
                        url.searchParams.append("acCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getDpDetailsByDPId = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getDPDetailsbyDPId);
                        url.searchParams.append("DpId", req.DpId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, GetDPDetailsByDPIdMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.sendOTP = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.sendOTP);
                        url.searchParams.append("Accode", req.Accode);
                        url.searchParams.append("incomeRange", req.incomeRange);
                        url.searchParams.append("flag", req.flag);
                        if (req.mobileNo !== "" &&
                            req.mobileNo !== undefined &&
                            req.mobileNo !== null) {
                            url.searchParams.append("MobileNo", req.mobileNo);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.verifyOTP = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.verifyOTP);
                        url.searchParams.append("Accode", req.Accode);
                        url.searchParams.append("otp", req.otp);
                        url.searchParams.append("Flag", req.Flag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.saveIncomeDeclaration = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.saveIncomeDeclaration);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.postIncomeClientValidation = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.PostIncomeClientValidation);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.postIncomeServiceRequest = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.PostIncomeServiceRequest);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    ClientRepository.prototype.subTypeMaster = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.subTypeMaster);
                        url.searchParams.append("CallTypId", req.CallTypId);
                        url.searchParams.append("isubtypid", req.isubtypid);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getPlanOffer = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.planOffer);
                        url.searchParams.append("acCode", req.acCode);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    ClientRepository.prototype.getExceptionlsin = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getExceptionlsin);
                        url.searchParams.append("searchText", req.searchText);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "100");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, GetExceptionlsinMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getExceptionData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getExceptionData);
                        url.searchParams.append("Accode", req.Accode);
                        url.searchParams.append("searchText", req.searchText);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, GetExceptionDataMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getExceptionSegment = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getExceptionSegment);
                        url.searchParams.append("Accode", req.Accode);
                        url.searchParams.append("page", "1");
                        url.searchParams.append("pageSize", "100");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, GetExceptionSegmentMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.saveExceptionHaircut = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.saveExceptionHaircut);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getMFRegistrationBookAccodeData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.mfRagistrationBookAccode);
                        url.searchParams.append("acCode", req.acCode);
                        url.searchParams.append("sipRegNo", req.sipRegNo);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, mfRegistrationBookAccodeMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.DNCSTD = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.dncstd);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, dncStdMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.DNCPendingStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.dncPendingSts);
                        url.searchParams.append("acCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, DNCPendingStsMapper(result === null || result === void 0 ? void 0 : result.data[0])];
                }
            });
        });
    };
    ClientRepository.prototype.DNCData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.dncData);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, DNCDataMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.POAEdis = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.poaEdis);
                        url.searchParams.append("acCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, POAEdisMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getFNOAvailableCashData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.fnoAvailableCashData);
                        url.searchParams.append("accode", req.accode);
                        url.searchParams.append("FromDate", req.FromDate);
                        url.searchParams.append("TxnYear", req.TxnYear);
                        url.searchParams.append("dataFrom", req.dataFrom);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, FNOAvailableCashDataMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.getCKYCDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.ckycDetails);
                        url.searchParams.append("accode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, CKYCDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.saveCKYC = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.saveCkycDetails);
                        url.searchParams.append("accode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, SaveCkycDetailsMapper(result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.deletePoaData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.deletePoa);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, deletePoaMapper(response)];
                }
            });
        });
    };
    ClientRepository.prototype.downloadKYC = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.downloadKYCData);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.downloadCMLReports = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.downloadCMLReports);
                        url.searchParams.append("DpAccNo", req.DpAccNo);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getClientBrokCommDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientBrokCommDetails);
                        url.searchParams.append("SchemeRefNo", req.SchemeRefNo);
                        url.searchParams.append("accode", req.accode);
                        url.searchParams.append("OnDate", req.OnDate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    ClientRepository.prototype.getClientBrokSubFeeDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientSubFeeDetails);
                        url.searchParams.append("SchemeRefNo", req.SchemeRefNo);
                        url.searchParams.append("accode", req.accode);
                        url.searchParams.append("OnDate", req.OnDate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    ClientRepository.prototype.getClientTierList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getClientTierListUrl);
                        url.searchParams.append("currentTier", req.currentTier);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    ClientRepository.prototype.getClientTierReasonList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getClientTierReasonListUrl);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    ClientRepository.prototype.saveHomogenousPostRMFeedbackData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.saveHomogenousPostRMFeedbackData);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.getTaskDetailsByTaskId = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getTaskDetailsByTaskId);
                        url.searchParams.append("TaskID", req.TaskID);
                        url.searchParams.append("DealerCode", req.DealerCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    ClientRepository.prototype.getFamilyRelations = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, familyrelations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getFamilyRelations);
                        url.searchParams.append("ucc", req.ucc);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        familyrelations = _a.sent();
                        return [2 /*return*/, familyrelations];
                }
            });
        });
    };
    ClientRepository.prototype.getFamily = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, familyData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getFamily);
                        url.searchParams.append("UccCode", req.UccCode);
                        url.searchParams.append("type", req.type);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        familyData = _a.sent();
                        return [2 /*return*/, familyData];
                }
            });
        });
    };
    ClientRepository.prototype.getFamilyMembers = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, familyMembers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.getFamilyMembers);
                        url.searchParams.append("FamilyCode", req.FamilyCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        familyMembers = _a.sent();
                        return [2 /*return*/, familyMembers];
                }
            });
        });
    };
    ClientRepository.prototype.createFamily = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, createFamilyResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.createFamily);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        createFamilyResponse = _a.sent();
                        return [2 /*return*/, createFamilyResponse];
                }
            });
        });
    };
    ClientRepository.prototype.updateFamilyName = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, updateFamilyNameResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.updateFamilyName);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        updateFamilyNameResponse = _a.sent();
                        return [2 /*return*/, updateFamilyNameResponse];
                }
            });
        });
    };
    ClientRepository.prototype.createFamilyMember = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, createFamilyMemberResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.createFamilyMember);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        createFamilyMemberResponse = _a.sent();
                        return [2 /*return*/, createFamilyMemberResponse];
                }
            });
        });
    };
    ClientRepository.prototype.createFamilyMemberMultiple = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, createFamilyMemberMultipleResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.createFamilyMemberMultiple);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        createFamilyMemberMultipleResponse = _a.sent();
                        return [2 /*return*/, createFamilyMemberMultipleResponse];
                }
            });
        });
    };
    ClientRepository.prototype.removeFamily = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, removeFamilyResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.removeFamily);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        removeFamilyResponse = _a.sent();
                        return [2 /*return*/, removeFamilyResponse];
                }
            });
        });
    };
    ClientRepository.prototype.removeFamilyMember = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, removeFamilyMemberResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.removeFamilyMember);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        removeFamilyMemberResponse = _a.sent();
                        return [2 /*return*/, removeFamilyMemberResponse];
                }
            });
        });
    };
    ClientRepository.prototype.clientFamilySearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, clientFamilySearchResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.clientFamilySearch);
                        url.searchParams.append("searchText", req.searchText);
                        url.searchParams.append("individual", String(req.individual));
                        url.searchParams.append("page", String(req.page));
                        url.searchParams.append("pageSize", String(req.pageSize));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        clientFamilySearchResponse = _a.sent();
                        return [2 /*return*/, clientFamilySearchResponse];
                }
            });
        });
    };
    ClientRepository.prototype.exitFamily = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, exitFamilyResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.exitFamily);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        exitFamilyResponse = _a.sent();
                        return [2 /*return*/, exitFamilyResponse];
                }
            });
        });
    };
    ClientRepository.prototype.consentCancel = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, consentCancelResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.consentCancel);
                        url.searchParams.append("consentid", String(req.consentid));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                            })];
                    case 1:
                        consentCancelResponse = _a.sent();
                        return [2 /*return*/, consentCancelResponse];
                }
            });
        });
    };
    ClientRepository.prototype.consentResend = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, consentResendResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.consentResend);
                        url.searchParams.append("consentid", String(req.consentid));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                            })];
                    case 1:
                        consentResendResponse = _a.sent();
                        return [2 /*return*/, consentResendResponse];
                }
            });
        });
    };
    ClientRepository.prototype.familyLinkingAccess = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.isMyClient);
                        url.searchParams.append("UccCode", req.UccCode);
                        url.searchParams.append("acCode", req.acCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ClientRepository.prototype.searchClientsByRmWithOwnClient = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, url, accessToken, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = new Headers();
                        headers.append("ApiKey", process.env.ELASTIC_SEARCH_CONFIG);
                        url = new URL(clientUrlConfig.searchClientsByRmWithOwnClient);
                        accessToken = localStorage.getItem(ELocalStorageKeys.AccessToken);
                        headers.append("Authorization", accessToken);
                        url.searchParams.append("userType", req.userType);
                        url.searchParams.append("userId", req.userId);
                        req.searchText && url.searchParams.append("searchText", req.searchText);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                headers: headers,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, searchClientsByRmWithOwnClientMapper(result === null || result === void 0 ? void 0 : result.data)];
                }
            });
        });
    };
    ClientRepository.prototype.validateClient = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.validateClient);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ClientRepository.prototype.recentClientSearchGet = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.recentClientSearchGet);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    ClientRepository.prototype.recentClientSearchSave = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(clientUrlConfig.recentClientSearchSave);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    return ClientRepository;
}());
export default ClientRepository;
